import ConversationMessageRecord from "models/view-models/conversations/conversation-message-record";
import { Dispatch } from "react";
import { ConversationsAction } from "utilities/atoms/conversations/current-conversation/conversation-atom.reducer";

/**
 * Starts a new conversation.
 * This thunk will create a new conversation and update the state accordingly.
 */
export const startConversation =
    (startConversationWithMessage?: ConversationMessageRecord) =>
    async (dispatch: Dispatch<ConversationsAction>) => {
        dispatch({
            type: "START_CONVERSATION",
            message: startConversationWithMessage,
        });
    };
